window.PH = window.PH || {};

PH.version = '3.5.0';
PH.debug = true;
PH.eventsBound = PH.eventsBound || false;

PH.MARTIN_PACKAGE_KEY = 'ph_martin_package_draft';
PH.MARTIN_ACTIVE_KEY = 'ph_martin_active_package';

PH.log = function (...args) {
  if (!PH.debug) return;
  console.log('[PH]', ...args);
};

PH.state = {
  mode: null,
  limit: 1,
  selected: [],
  search: '',
  activeFilter: null,
  category: '',
  catalog: [],
  ready: false,

  martin: {
    active: false,
    draft: null,
    pool: [],
    dismissed: false,
    preview: []
  }
};

PH.elements = {};

PH.normalize = function (text) {
  return String(text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
};

PH.escapeHtml = function (value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
};

PH.resolveCategory = function (filter) {
  const text = PH.normalize([
    filter?.id,
    filter?.label,
    filter?.tag
  ].join(' '));

  if (
    text.includes('caballero') ||
    text.includes('hombre')
  ) {
    return 'caballero';
  }

  if (
    text.includes('dama') ||
    text.includes('mujer')
  ) {
    return 'dama';
  }

  if (text.includes('nicho')) {
    return 'nicho';
  }

  if (text.includes('arabe')) {
    return 'arabes';
  }

  if (text.includes('unisex')) {
    return 'unisex';
  }

  return '';
};

PH.findVisibleHomeRoot = function () {
  const roots = Array.from(
    document.querySelectorAll(
      '[data-ph-home-search]'
    )
  );

  return (
    roots.find(element => {
      const styles =
        window.getComputedStyle(element);

      return (
        styles.display !== 'none' &&
        styles.visibility !== 'hidden' &&
        element.getClientRects().length > 0
      );
    }) ||
    roots[0] ||
    null
  );
};

PH.bindRootElements = function (root) {
  if (!root) return;

  PH.elements.root = root;

  PH.elements.counter =
    root.querySelector(
      '[data-ph-counter], #ph-counter'
    );

  PH.elements.searchInput =
    root.querySelector(
      '[data-ph-search-input]'
    );

  PH.elements.searchClear =
    root.querySelector(
      '[data-ph-search-clear]'
    );

  PH.elements.searchResults =
    root.querySelector(
      '[data-ph-search-results]'
    );

  PH.elements.selectedList =
    root.querySelector(
      '[data-ph-selected-list]'
    );

  PH.elements.progressBar =
    root.querySelector(
      '[data-ph-progress-bar]'
    );

  PH.elements.completeMessage =
    root.querySelector(
      '[data-ph-complete]'
    );

  PH.elements.assistant =
    root.querySelector(
      '[data-ph-assistant]'
    );

  PH.elements.advisor =
    root.querySelector(
      '[data-ph-advisor]'
    );
};

PH.cacheElements = function () {
  PH.elements.packageRoot =
    document.querySelector(
      '[data-ph-package-selector]'
    );

  PH.elements.productRoot =
    document.querySelector(
      '[data-ph-product-search]'
    );

  PH.elements.homeRoot =
    PH.findVisibleHomeRoot();

  const root =
    PH.elements.packageRoot ||
    PH.elements.productRoot ||
    PH.elements.homeRoot;

  if (PH.elements.packageRoot) {
    PH.state.mode = 'package';
  } else if (PH.elements.productRoot) {
    PH.state.mode = 'product';
  } else {
    PH.state.mode = 'home';
  }

  PH.bindRootElements(root);

  PH.elements.form =
    document.querySelector(
      'form[action*="/cart/add"]'
    );

  PH.elements.packageName =
    PH.elements.packageRoot
      ? PH.elements.packageRoot.querySelector(
          '[data-ph-package-name]'
        )
      : null;

  PH.elements.packageIntro =
    PH.elements.packageRoot
      ? PH.elements.packageRoot.querySelector(
          '[data-ph-package-intro]'
        )
      : null;

  PH.elements.martinBlock =
    PH.elements.packageRoot
      ? PH.elements.packageRoot.querySelector(
          '[data-ph-martin-continuation]'
        )
      : null;

  PH.elements.martinRecommendations =
    PH.elements.packageRoot
      ? PH.elements.packageRoot.querySelector(
          '[data-ph-martin-recommendations]'
        )
      : null;

  PH.elements.martinAutoModal =
    document.querySelector(
      '[data-ph-martin-auto-modal]'
    );

  PH.elements.martinAutoList =
    document.querySelector(
      '[data-ph-martin-auto-list]'
    );

  /*
   * El modal debe vivir directamente dentro de <body>.
   * Algunos contenedores del tema crean un contexto propio
   * que hace que position: fixed se comporte como si fuera
   * relativo a la sección, especialmente en Safari/iPhone.
   */
  if (
    PH.elements.martinAutoModal &&
    PH.elements.martinAutoModal.parentElement !== document.body
  ) {
    document.body.appendChild(
      PH.elements.martinAutoModal
    );
  }
};

PH.productImage = function (product) {
  return (
    product?.image ||
    product?.featured_image ||
    product?.featuredImage ||
    product?.images?.[0]?.src ||
    product?.images?.[0] ||
    ''
  );
};

PH.isAvailable = function (product) {
  if (!product) return false;

  if (product.available === false) {
    return false;
  }

  if (
    Array.isArray(product.variants) &&
    product.variants.length > 0
  ) {
    return product.variants.some(
      variant =>
        variant.available !== false
    );
  }

  return true;
};

PH.readMartinPackageDraft = function () {
  try {
    const raw =
      sessionStorage.getItem(
        PH.MARTIN_PACKAGE_KEY
      );

    if (!raw) return null;

    const draft = JSON.parse(raw);

    if (
      !draft ||
      ![3, 5, 10].includes(
        Number(draft.packageSize)
      ) ||
      !(
        draft.perfume ||
        draft.selectedPerfume
      )
    ) {
      return null;
    }

    return draft;
  } catch (error) {
    PH.log(
      'No se pudo leer el paquete de Martín:',
      error
    );

    return null;
  }
};

PH.readMartinActive = function () {
  try {
    const raw =
      sessionStorage.getItem(
        PH.MARTIN_ACTIVE_KEY
      );

    return raw
      ? JSON.parse(raw)
      : null;
  } catch (error) {
    PH.log(
      'No se pudo leer la sesión activa de Martín:',
      error
    );

    return null;
  }
};

PH.saveMartinActive = function () {
  try {
    if (
      !PH.state.martin.active ||
      !PH.state.martin.draft
    ) {
      sessionStorage.removeItem(
        PH.MARTIN_ACTIVE_KEY
      );

      return;
    }

    sessionStorage.setItem(
      PH.MARTIN_ACTIVE_KEY,
      JSON.stringify({
        ...PH.state.martin.draft,

        selectedIds:
          PH.state.selected.map(
            item => String(item.id)
          ),

        dismissed:
          PH.state.martin.dismissed,

        updatedAt:
          Date.now()
      })
    );
  } catch (error) {
    PH.log(
      'No se pudo guardar la sesión activa de Martín:',
      error
    );
  }
};

PH.findMartinPerfume = function (perfume) {
  if (!perfume) return null;

  const id =
    PH.normalize(perfume.id);

  const handle =
    PH.normalize(perfume.handle);

  const name =
    PH.normalize(
      perfume.name ||
      perfume.title
    );

  return (
    PH.state.catalog.find(product => {
      return (
        (
          id &&
          PH.normalize(product.id) === id
        ) ||
        (
          handle &&
          PH.normalize(product.handle) ===
            handle
        ) ||
        (
          name &&
          PH.normalize(
            product.name ||
            product.title
          ) === name
        )
      );
    }) ||
    null
  );
};

PH.resolveMartinPool = function (draft) {
  const source =
    Array.isArray(
      draft?.recommendationPool
    )
      ? draft.recommendationPool
      : [];

  return source
    .map(item => {
      const product =
        PH.findMartinPerfume(item);

      if (
        !product ||
        !PH.isAvailable(product)
      ) {
        return null;
      }

      return {
        ...product,

        martinRole:
          item.martinRole ||
          item.role ||
          'Recomendación de Martín',

        martinReason:
          item.martinReason ||
          item.reason ||
          'Una opción que combina muy bien con lo que estás buscando.'
      };
    })
    .filter(Boolean);
};

PH.remainingSlots = function () {
  return Math.max(
    0,
    PH.state.limit -
      PH.state.selected.length
  );
};

PH.getMartinSuggestions = function () {
  const selectedIds =
    new Set(
      PH.state.selected.map(
        item => String(item.id)
      )
    );

  return PH.state.martin.pool
    .filter(item => {
      return (
        PH.isAvailable(item) &&
        !selectedIds.has(
          String(item.id)
        )
      );
    })
    .slice(
      0,
      Math.min(
        4,
        PH.remainingSlots()
      )
    );
};
PH.renderMartinContinuation = function () {
  const block =
    PH.elements.martinBlock;

  if (!block) return;

  const shouldShow =
    PH.state.mode === 'package' &&
    PH.state.martin.active &&
    !PH.state.martin.dismissed &&
    PH.remainingSlots() > 0;

  block.hidden = !shouldShow;

  if (PH.elements.packageIntro) {
    PH.elements.packageIntro.textContent =
      shouldShow
        ? 'Ya elegimos el primero. Martín puede ayudarte a completar tu paquete.'
        : 'Busca y agrega tus aromas favoritos.';
  }

  if (
    !shouldShow ||
    !PH.elements.martinRecommendations
  ) {
    return;
  }

  const suggestions =
    PH.getMartinSuggestions();

  if (!suggestions.length) {
    PH.elements.martinRecommendations.innerHTML = `
      <div class="ph-martin-package-empty">
        <strong>
          Ya no tengo más sugerencias disponibles.
        </strong>

        <p>
          Puedes completar los espacios restantes con el buscador.
        </p>
      </div>
    `;

    return;
  }

  PH.elements.martinRecommendations.innerHTML =
    suggestions
      .map(item => {
        const title =
          item.name ||
          item.title ||
          'Perfume PH';

        const image =
          PH.productImage(item);

        return `
          <article class="ph-martin-package-card">

            <span class="ph-martin-package-card__image">
              ${
                image
                  ? `
                    <img
                      src="${PH.escapeHtml(image)}"
                      alt="${PH.escapeHtml(title)}"
                      loading="lazy"
                      width="400"
                      height="400"
                    >
                  `
                  : '<span>PH</span>'
              }
            </span>

            <div class="ph-martin-package-card__body">

              <span class="ph-martin-package-card__role">
                ${PH.escapeHtml(item.martinRole)}
              </span>

              <strong>
                ${PH.escapeHtml(title)}
              </strong>

              <p
                class="ph-martin-package-card__reason"
                data-ph-martin-reason
              >
                ${PH.escapeHtml(item.martinReason)}
              </p>

              <button
                type="button"
                class="ph-martin-package-card__read-more"
                data-ph-martin-read-more
                aria-expanded="false"
              >
                Leer más
              </button>

            </div>

            <div class="ph-martin-package-card__actions">

              <button
                type="button"
                data-ph-martin-add="${PH.escapeHtml(item.id)}"
              >
                Agregar
              </button>

              <button
                type="button"
                class="is-secondary"
                data-ph-martin-skip="${PH.escapeHtml(item.id)}"
              >
                Ver otra
              </button>

            </div>

          </article>
        `;
      })
      .join('');
};

PH.openMartinAutoPreview = function () {
  const remaining =
    PH.remainingSlots();

  if (!remaining) return;

  const selectedIds =
    new Set(
      PH.state.selected.map(
        item => String(item.id)
      )
    );

  const candidates =
    PH.state.martin.pool
      .filter(item => {
        return (
          PH.isAvailable(item) &&
          !selectedIds.has(
            String(item.id)
          )
        );
      })
      .slice(0, remaining);

  if (!candidates.length) {
    alert(
      'No encontré suficientes recomendaciones disponibles para completar el paquete.'
    );

    return;
  }

  PH.state.martin.preview =
    candidates;

  if (PH.elements.martinAutoList) {
    const allItems = [
      ...PH.state.selected.map(
        item => ({
          ...item,
          isCurrent: true
        })
      ),
      ...candidates
    ];

    PH.elements.martinAutoList.innerHTML =
      allItems
        .map(item => {
          const title =
            item.name ||
            item.title ||
            'Perfume PH';

          return `
            <li>
              <span>
                ${item.isCurrent ? '✓' : '＋'}
              </span>

              <strong>
                ${PH.escapeHtml(title)}
              </strong>

              ${
                item.isCurrent
                  ? '<small>Ya seleccionado</small>'
                  : ''
              }
            </li>
          `;
        })
        .join('');

    PH.elements.martinAutoList.scrollTop = 0;
  }

  if (PH.elements.martinAutoModal) {
    if (
      PH.elements.martinAutoModal.parentElement !== document.body
    ) {
      document.body.appendChild(
        PH.elements.martinAutoModal
      );
    }

    PH.elements.martinAutoModal.hidden =
      false;

    PH.elements.martinAutoModal.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.style.overflow =
      'hidden';

    requestAnimationFrame(() => {
      const dialog =
        PH.elements.martinAutoModal.querySelector(
          '.ph-martin-auto-modal__dialog'
        );

      if (dialog) {
        dialog.scrollTop = 0;
      }

      if (PH.elements.martinAutoList) {
        PH.elements.martinAutoList.scrollTop = 0;
      }
    });
  }
};

PH.closeMartinAutoPreview = function () {
  if (
    !PH.elements.martinAutoModal
  ) {
    return;
  }

  PH.elements.martinAutoModal.hidden =
    true;

  PH.elements.martinAutoModal.setAttribute(
    'aria-hidden',
    'true'
  );

  document.body.style.overflow = '';
};

PH.confirmMartinAutoFill = function () {
  const remaining =
    PH.remainingSlots();

  PH.state.martin.preview
    .slice(0, remaining)
    .forEach(item => {
      const exists =
        PH.state.selected.some(
          selected =>
            String(selected.id) ===
            String(item.id)
        );

      if (
        !exists &&
        PH.state.selected.length <
          PH.state.limit
      ) {
        PH.state.selected.push(item);
      }
    });

  PH.state.martin.preview = [];

  PH.closeMartinAutoPreview();
  PH.saveMartinActive();
  PH.render();
};

PH.dismissMartin = function () {
  PH.state.martin.dismissed = true;

  PH.saveMartinActive();
  PH.renderMartinContinuation();

  if (PH.elements.searchInput) {
    PH.elements.searchInput.focus();
  }
};

PH.selectPackageSize = function (size) {
  const normalizedSize =
    Number(size);

  if (
    ![3, 5, 10].includes(
      normalizedSize
    )
  ) {
    return;
  }

  const radios =
    Array.from(
      document.querySelectorAll(
        'input[type="radio"]'
      )
    );

  const matchingRadio =
    radios.find(radio => {
      const value =
        parseInt(
          String(
            radio.value || ''
          ).trim(),
          10
        );

      return value === normalizedSize;
    });

  if (matchingRadio) {
    matchingRadio.checked = true;

    matchingRadio.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );
  }

  PH.state.limit = normalizedSize;

  if (PH.elements.counter) {
    PH.elements.counter.textContent =
      `${PH.state.selected.length}/${normalizedSize}`;
  }

  if (PH.elements.packageName) {
    PH.syncPackageProperty(
      normalizedSize
    );
  }
};

PH.syncPackageProperty = function (
  size
) {
  const input =
    PH.elements.packageName;

  if (!input) {
    return;
  }

  const normalizedSize =
    Number(size);

  const isRealPackage =
    PH.state.mode === 'package' &&
    [3, 5, 10].includes(
      normalizedSize
    );

  if (isRealPackage) {
    input.disabled = false;
    input.name =
      'properties[Paquete]';
    input.value =
      `Paquete ${normalizedSize}`;
    return;
  }

  input.disabled = true;
  input.removeAttribute('name');
  input.value = '';
};

PH.applyMartinPackageDraft = function () {
  if (
    PH.state.mode !== 'package'
  ) {
    return;
  }

  const incomingDraft =
    PH.readMartinPackageDraft();

  const activeDraft =
    PH.readMartinActive();

  const draft =
    incomingDraft ||
    activeDraft;

  if (
    !draft ||
    draft.cameFromMartin !== true
  ) {
    PH.state.martin.active = false;
    PH.renderMartinContinuation();

    return;
  }

  PH.state.martin.active = true;
  PH.state.martin.draft = draft;
  PH.state.martin.dismissed =
    Boolean(draft.dismissed);

  PH.selectPackageSize(
    draft.packageSize
  );

  const perfume =
    PH.findMartinPerfume(
      draft.perfume ||
      draft.selectedPerfume
    );

  if (
    perfume &&
    PH.isAvailable(perfume)
  ) {
    const exists =
      PH.state.selected.some(
        item =>
          String(item.id) ===
          String(perfume.id)
      );

    if (!exists) {
      PH.state.selected.unshift(
        perfume
      );
    }
  }

  PH.state.martin.pool =
    PH.resolveMartinPool(draft);

  try {
    sessionStorage.removeItem(
      PH.MARTIN_PACKAGE_KEY
    );
  } catch (error) {
    PH.log(
      'No se pudo limpiar el borrador de Martín:',
      error
    );
  }

  PH.saveMartinActive();
  PH.render();

  window.setTimeout(() => {
    PH.elements.packageRoot
      ?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
  }, 250);
};

PH.getLimit = function () {
  const checkedRadio =
    document.querySelector(
      'input[type="radio"]:checked'
    );

  if (!checkedRadio) {
    return 1;
  }

  const number =
    parseInt(
      String(
        checkedRadio.value || ''
      ).trim(),
      10
    );

  return Number.isNaN(number)
    ? 1
    : number;
};

PH.setLimit = function () {
  if (
    PH.state.mode !== 'package'
  ) {
    return;
  }

  PH.state.limit =
    PH.getLimit();

  if (
    PH.state.selected.length >
    PH.state.limit
  ) {
    PH.state.selected =
      PH.state.selected.slice(
        0,
        PH.state.limit
      );
  }

  if (PH.elements.packageName) {
    PH.syncPackageProperty(
      PH.state.limit
    );
  }

  PH.render();
};
PH.getQuery = function () {
  return String(
    PH.state.search || ''
  ).trim();
};

PH.findCatalogProduct = function (
  recommended
) {
  if (!recommended) {
    return null;
  }

  const recommendedId =
    PH.normalize(
      recommended.id
    );

  const recommendedHandle =
    PH.normalize(
      recommended.handle
    );

  const recommendedName =
    PH.normalize(
      recommended.name ||
      recommended.title
    );

  return (
    PH.state.catalog.find(product => {
      const productId =
        PH.normalize(
          product.id
        );

      const productHandle =
        PH.normalize(
          product.handle
        );

      const productName =
        PH.normalize(
          product.name ||
          product.title
        );

      return (
        (
          recommendedId &&
          productId === recommendedId
        ) ||
        (
          recommendedId &&
          productHandle ===
            recommendedId
        ) ||
        (
          recommendedHandle &&
          productHandle ===
            recommendedHandle
        ) ||
        (
          recommendedName &&
          productName ===
            recommendedName
        )
      );
    }) ||
    null
  );
};

PH.productMatchesFilter = function (
  product,
  activeFilter
) {
  if (
    !product ||
    !PH.isAvailable(product)
  ) {
    return false;
  }

  const filter =
    PH.normalize(activeFilter);

  const taxonomyGender =
    Array.isArray(
      product.taxonomy?.gender
    )
      ? product.taxonomy.gender
      : [];

  const taxonomyFamilies =
    Array.isArray(
      product.taxonomy?.families
    )
      ? product.taxonomy.families
      : [];

  const text =
    PH.normalize([
      product.name,
      product.title,
      product.fullName,
      product.handle,
      product.vendor,
      product.brand,
      product.type,
      product.tags,
      product.gender,
      product.category,
      ...(product.categories || []),
      ...taxonomyGender,
      ...taxonomyFamilies,
      product.searchText
    ].join(' '));

  const aliases = {
    caballero: [
      'caballero',
      'hombre',
      'masculino',
      'men',
      'tendencia c'
    ],

    dama: [
      'dama',
      'mujer',
      'femenino',
      'women',
      'tendencia d'
    ],

    unisex: [
      'unisex',
      'tendencia u'
    ],

    nicho: [
      'nicho',
      'niche'
    ],

    arabes: [
      'arabe',
      'arabes'
    ]
  };

  if (
    ['caballero', 'dama', 'unisex']
      .includes(filter)
  ) {
    const gender =
      PH.normalize(
        product.gender
      );

    if (gender === filter) {
      return true;
    }
  }

  if (
    ['nicho', 'arabes']
      .includes(filter)
  ) {
    const category =
      PH.normalize(
        product.category
      );

    if (category === filter) {
      return true;
    }
  }

  const terms =
    aliases[filter] ||
    [filter];

  return terms.some(term =>
    text.includes(
      PH.normalize(term)
    )
  );
};

PH.getSearchResults = function () {
  const query = PH.getQuery();

  /*
   * CAMINO 1:
   * Los chips filtran el catálogo sin escribir
   * su nombre dentro del buscador.
   */
  if (
    PH.state.activeFilter &&
    query.length === 0 &&
    Array.isArray(PH.state.catalog)
  ) {
    return PH.state.catalog
      .filter(product =>
        PH.productMatchesFilter(
          product,
          PH.state.activeFilter
        )
      )
      .slice(0, 20);
  }

  /*
   * Sin búsqueda y sin chip activo:
   * no mostramos resultados.
   */
  if (query.length < 2) {
    return [];
  }

  let results = [];

  /*
   * CAMINO 2:
   * Búsqueda escrita normal.
   */
  if (
    PH.searchEngine &&
    typeof PH.searchEngine.search ===
      'function'
  ) {
    try {
      results =
        PH.searchEngine.search(
          query,
          {
            limit: 30,
            hideUnavailable: false,
            category: ''
          }
        ) || [];
    } catch (error) {
      PH.log(
        'Error en búsqueda directa:',
        error
      );

      results = [];
    }
  }

  /*
   * Segunda validación:
   * elimina coincidencias demasiado amplias.
   */
  if (
    PH.recommendation &&
    typeof PH.recommendation.filterResults ===
      'function'
  ) {
    try {
      results =
        PH.recommendation.filterResults(
          query,
          results
        ) || [];
    } catch (error) {
      PH.log(
        'Error afinando resultados:',
        error
      );
    }
  }

  /*
   * Respaldo semántico únicamente cuando
   * la búsqueda directa no encontró nada.
   */
  if (
    results.length === 0 &&
    window.PHBrain &&
    typeof window.PHBrain.recommend ===
      'function'
  ) {
    try {
      const brainResults =
        window.PHBrain.recommend(
          query
        ) || [];

      results = brainResults
        .map(PH.findCatalogProduct)
        .filter(Boolean);
    } catch (error) {
      PH.log(
        'Error ejecutando PHBrain:',
        error
      );

      results = [];
    }
  }

  if (
    PH.state.mode === 'package'
  ) {
    results = results.filter(item =>
      !PH.state.selected.some(
        selected =>
          String(selected.id) ===
          String(item.id)
      )
    );
  }

  const uniqueResults = [];
  const seen = new Set();

  results.forEach(item => {
    const key = String(
      item.id ||
      item.handle ||
      item.name ||
      item.title
    );

    if (seen.has(key)) {
      return;
    }

    seen.add(key);
    uniqueResults.push(item);
  });

  if (
    PH.recommendation &&
    typeof PH.recommendation.enrich ===
      'function'
  ) {
    return uniqueResults
      .map(item =>
        PH.recommendation.enrich(
          item,
          query
        )
      )
      .slice(0, 20);
  }

  return uniqueResults.slice(0, 20);
};

PH.getAdvice = function (results) {
  const query =
    PH.getQuery();

  if (
    !PH.advisor ||
    typeof PH.advisor.getAdvice !==
      'function'
  ) {
    return null;
  }

  return PH.advisor.getAdvice(
    query,
    results
  );
};

PH.addFragrance = function (item) {
  if (
    PH.state.mode === 'home' ||
    PH.state.mode === 'product'
  ) {
    window.location.href =
      `/products/${item.handle}`;

    return;
  }

  const exists =
    PH.state.selected.some(
      selected =>
        String(selected.id) ===
        String(item.id)
    );

  if (exists) {
    return;
  }

  if (
    PH.state.selected.length >=
    PH.state.limit
  ) {
    alert(
      `Solo puedes seleccionar ${PH.state.limit} aromas.`
    );

    return;
  }

  PH.state.selected.push(item);

  PH.state.search = '';
  PH.state.activeFilter = null;
  PH.state.category = '';

  if (PH.elements.searchInput) {
    PH.elements.searchInput.value = '';
  }

  PH.saveMartinActive();
  PH.render();
};

PH.removeFragrance = function (id) {
  PH.state.selected =
    PH.state.selected.filter(
      item =>
        String(item.id) !==
        String(id)
    );

  PH.saveMartinActive();
  PH.render();

};

PH.syncProperties = function () {
  if (
    PH.state.mode !== 'package'
  ) {
    return;
  }

  if (!PH.elements.form) {
    return;
  }

  PH.elements.form
    .querySelectorAll(
      '[data-ph-cart-property]'
    )
    .forEach(input =>
      input.remove()
    );

  PH.state.selected.forEach(
    (item, index) => {
      const input =
        document.createElement(
          'input'
        );

      input.type = 'hidden';

      input.name =
        `properties[Aroma ${index + 1}]`;

      input.value =
        item.name ||
        item.title;

      input.setAttribute(
        'data-ph-cart-property',
        'true'
      );

      PH.elements.form.appendChild(
        input
      );
    }
  );
};

PH.render = function () {
  const results =
    PH.getSearchResults();

  const advice =
    PH.getAdvice(results);

  if (PH.elements.searchClear) {
    PH.elements.searchClear.hidden =
      !PH.state.search.trim();
  }

  if (PH.ui) {
    PH.ui.renderAssistant(
      PH.elements.assistant,
      PH.filters
        ? PH.filters.categories
        : [],
      PH.state.activeFilter
    );

    PH.ui.renderAdvisor(
      PH.elements.advisor,
      advice
    );

    PH.ui.renderSearchResults(
      PH.elements.searchResults,
      results
    );

    if (
      PH.state.mode === 'package'
    ) {
      PH.ui.renderCounter(
        PH.elements.counter,
        PH.state.selected,
        PH.state.limit
      );

      PH.ui.renderProgress(
        PH.elements.progressBar,
        PH.state.selected,
        PH.state.limit
      );

      PH.ui.renderSelectedList(
        PH.elements.selectedList,
        PH.state.selected
      );

      PH.ui.renderCompleteMessage(
        PH.elements.completeMessage,
        PH.state.selected,
        PH.state.limit
      );
    }
  }

  PH.renderMartinContinuation();
  PH.syncProperties();
};

PH.rebindClickedRoot = function (
  clickedElement
) {
  const clickedRoot =
    clickedElement.closest(
      '[data-ph-home-search], [data-ph-package-selector], [data-ph-product-search]'
    );

  if (!clickedRoot) {
    return;
  }

  const isPackage =
    clickedRoot.matches(
      '[data-ph-package-selector]'
    );

  const isProduct =
    clickedRoot.matches(
      '[data-ph-product-search]'
    );

  PH.state.mode =
    isPackage
      ? 'package'
      : isProduct
        ? 'product'
        : 'home';

  PH.elements.packageRoot =
    isPackage
      ? clickedRoot
      : null;

  PH.elements.productRoot =
    isProduct
      ? clickedRoot
      : null;

  PH.elements.homeRoot =
    !isPackage && !isProduct
      ? clickedRoot
      : null;

  PH.bindRootElements(
    clickedRoot
  );
};

PH.bindEvents = function () {
  if (PH.eventsBound) {
    PH.log(
      'Los eventos ya estaban enlazados'
    );

    return;
  }

  PH.eventsBound = true;

  document.addEventListener(
    'input',
    event => {
      if (
        !event.target.matches(
          '[data-ph-search-input]'
        )
      ) {
        return;
      }

      PH.rebindClickedRoot(
        event.target
      );

      PH.state.search =
        event.target.value;

      PH.state.activeFilter = null;
      PH.state.category = '';

      PH.render();
    }
  );

  document.addEventListener(
    'click',
    event => {
      const add =
        event.target.closest(
          '[data-ph-add-fragrance]'
        );

      const remove =
        event.target.closest(
          '[data-ph-remove-fragrance]'
        );

      const filter =
        event.target.closest(
          '[data-ph-filter]'
        );

      const clear =
        event.target.closest(
          '[data-ph-search-clear]'
        );

      const packageButton =
        event.target.closest(
          '.ph-package-btn'
        );

      const martinAdd =
        event.target.closest(
          '[data-ph-martin-add]'
        );

      const martinSkip =
        event.target.closest(
          '[data-ph-martin-skip]'
        );

      const martinAuto =
        event.target.closest(
          '[data-ph-martin-auto]'
        );

      const martinOwn =
        event.target.closest(
          '[data-ph-martin-own]'
        );

      const martinAutoClose =
        event.target.closest(
          '[data-ph-martin-auto-close]'
        );

      const martinAutoConfirm =
        event.target.closest(
          '[data-ph-martin-auto-confirm]'
        );

      const martinReadMore =
        event.target.closest(
          '[data-ph-martin-read-more]'
        );

      if (martinReadMore) {
        const card =
          martinReadMore.closest(
            '.ph-martin-package-card'
          );

        const reason =
          card
            ? card.querySelector(
                '[data-ph-martin-reason]'
              )
            : null;

        if (reason) {
          const expanded =
            reason.classList.toggle(
              'is-expanded'
            );

          martinReadMore.textContent =
            expanded
              ? 'Ver menos'
              : 'Leer más';

          martinReadMore.setAttribute(
            'aria-expanded',
            String(expanded)
          );
        }

        return;
      }

      if (martinAdd) {
        PH.rebindClickedRoot(
          martinAdd
        );

        const item =
          PH.state.martin.pool.find(
            product =>
              String(product.id) ===
              String(
                martinAdd.dataset
                  .phMartinAdd
              )
          );

        if (item) {
          PH.addFragrance(item);
        }

        return;
      }

      if (martinSkip) {
        const id =
          String(
            martinSkip.dataset
              .phMartinSkip
          );

        const index =
          PH.state.martin.pool.findIndex(
            product =>
              String(product.id) === id
          );

        if (index >= 0) {
          const [item] =
            PH.state.martin.pool.splice(
              index,
              1
            );

          PH.state.martin.pool.push(
            item
          );

          PH.saveMartinActive();
          PH.renderMartinContinuation();
        }

        return;
      }

      if (martinAuto) {
        PH.openMartinAutoPreview();
        return;
      }

      if (martinOwn) {
        PH.dismissMartin();
        return;
      }

      if (martinAutoClose) {
        PH.closeMartinAutoPreview();
        return;
      }

      if (martinAutoConfirm) {
        PH.confirmMartinAutoFill();
        return;
      }

      if (clear) {
        PH.rebindClickedRoot(
          clear
        );

        PH.state.search = '';
        PH.state.activeFilter = null;
        PH.state.category = '';

        if (PH.elements.searchInput) {
          PH.elements.searchInput.value =
            '';

          PH.elements.searchInput.focus();
        }

        PH.render();
        return;
      }

      if (packageButton) {
        PH.rebindClickedRoot(
          packageButton
        );

        const limit =
          Number(
            packageButton.dataset.limit
          );

        if (
          [3, 5, 10].includes(limit)
        ) {
          PH.state.limit = limit;

          document
            .querySelectorAll(
              '.ph-package-btn'
            )
            .forEach(button => {
              button.classList.toggle(
                'is-active',
                button ===
                  packageButton
              );
            });

          if (
            PH.elements.packageName
          ) {
            PH.syncPackageProperty(
              limit
            );
          }

          PH.render();
        }

        return;
      }

      if (filter) {
        PH.rebindClickedRoot(
          filter
        );

        const id =
          filter.dataset.phFilter;

        const filterData =
          PH.filters
            ? PH.filters.categories.find(
                item =>
                  item.id === id
              )
            : null;

        const isSame =
          PH.state.activeFilter === id;

        PH.state.activeFilter =
          isSame
            ? null
            : id;

        PH.state.category =
          isSame
            ? ''
            : PH.resolveCategory(
                filterData
              );

        PH.state.search = '';

        if (
          PH.elements.searchInput
        ) {
          PH.elements.searchInput.value = '';
          PH.elements.searchInput.blur();
        }

        PH.render();

        if (
          PH.elements.searchResults &&
          !isSame
        ) {
          window.setTimeout(() => {
            PH.elements.searchResults.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });
          }, 80);
        }

        return;
      }
            if (add) {
        PH.rebindClickedRoot(
          add
        );

        const item =
          PH.state.catalog.find(
            product =>
              String(product.id) ===
              String(
                add.dataset
                  .phAddFragrance
              )
          );

        if (item) {
          PH.addFragrance(item);
        }

        return;
      }

      if (remove) {
        PH.rebindClickedRoot(
          remove
        );

        PH.removeFragrance(
          remove.dataset
            .phRemoveFragrance
        );

        return;
      }
    }
  );

  document.addEventListener(
    'change',
    event => {
      if (
        !event.target.matches(
          'input[type="radio"]'
        )
      ) {
        return;
      }

      PH.setLimit();
    }
  );
};

PH.init = async function () {
  PH.cacheElements();

  if (!PH.elements.root) {
    PH.log(
      'No hay widget PH en esta página'
    );

    return;
  }

  if (
    PH.catalog &&
    typeof PH.catalog.load ===
      'function'
  ) {
    try {
      await PH.catalog.load();

      if (
        Array.isArray(
          PH.catalog.products
        ) &&
        PH.catalog.products.length > 0
      ) {
        PH.state.catalog =
          PH.catalog.products;
      }
    } catch (error) {
      PH.log(
        'Error cargando el catálogo:',
        error
      );
    }
  }

  if (
    PH.state.mode === 'package'
  ) {
    const martinDraft =
      PH.readMartinPackageDraft();

    if (martinDraft) {
      PH.state.limit =
        Number(
          martinDraft.packageSize
        );
    } else {
      PH.state.limit =
        PH.getLimit();
    }
  }

  PH.bindEvents();

  if (
    PH.state.mode === 'package'
  ) {
    PH.applyMartinPackageDraft();
  } else {
    PH.render();
  }

  PH.state.ready = true;

  PH.log(
    `App inicializada en modo ${PH.state.mode}`,
    {
      catalog:
        PH.state.catalog.length,
      activeFilter:
        PH.state.activeFilter,
      root:
        PH.elements.root
    }
  );
};

document.addEventListener(
  'DOMContentLoaded',
  PH.init
);
